<template>
  <div>
    <v-dialog
      v-model="mod_dialog"
      flat
      persistent
      max-width="900"
      content-class="br_none"
    >
      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title" v-show="procStatus === 'MOD'">{{ $t('component.applicants.edit_applicant') }}</h2>
              <h2 class="modal__title" v-show="procStatus === 'VIEW'">{{ $t('component.applicants.view_applicant') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="fnClosePopup()"></v-btn>
            </div>
          </div>
        </v-col>

        <v-col cols="12" class="pa-0">
          <ValidationObserver ref="observer">
            <v-form v-model="valid">
              <perfect-scrollbar class="h420" id="applicant_wrapper">
                <div class="modal__content__inner__new">
                  <v-row class="ma-0">
                    <v-col cols="12">
                      <v-row>
                        <v-col>
                          <label class="nec_title"><i>*</i> {{ $t('component.applicants.applicant_type') }}</label>
                          <div class="input_text_type_basic">
                            <v-select
                              dense
                              outlined
                              hide-details
                              class="ft-size12 br_none"
                              :disabled="procStatus === 'VIEW'"
                              :items="$vuetify.rtl ? applicantTypeListAr : applicantTypeListEn"
                              v-model="applicant_type_code"
                            >
                            </v-select>
                          </div>
                        </v-col>

                        <v-col>
                          <label class="nec_title"><i>*</i> {{ $t('component.applicants.nationality') }}</label>
                          <div class="input_text_type_basic">
                            <v-select
                              dense
                              outlined
                              hide-details
                              class="ft-size12 br_none"
                              :disabled="procStatus === 'VIEW'"
                              :items="$vuetify.rtl ? countryArList : countryEnList"
                              v-model="nationality_code"
                            >
                            </v-select>
                          </div>
                        </v-col>

                        <v-col>
                          <label class="nec_title"><i>*</i> {{ $t('component.applicants.residence') }}</label>
                          <div class="input_text_type_basic">
                            <v-select
                              dense
                              outlined
                              hide-details
                              class="ft-size12 br_none"
                              :disabled="procStatus === 'VIEW'"
                              :items="$vuetify.rtl ? countryArList : countryEnList"
                              v-model="residence_country_code"
                            >
                            </v-select>
                          </div>
                        </v-col>
                      </v-row>

                    </v-col>

                    <v-col cols="12">
                      <v-row>
                        <v-col class="pt-0">
                          <label class="nec_title"><i>*</i> {{ $t('component.applicants.name') }}</label>
                          <v-row>
                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="box__title">{{ $t('component.applicants.en') }}</div>
                                <div class="text__input__icontype__tf">
                                  <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.name')" :rules="{required: true}">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="br_none ie_inpt login_text_field text-left"
                                    :disabled="procStatus === 'VIEW'"
                                    v-model="name_en"
                                    :error-messages="errors"
                                  ></v-text-field>
                                  </ValidationProvider>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="text__input__icontype__tf">
                                  <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.name')" :rules="{required: true}">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="type_ar ie_inpt login_text_field text-right br_none"
                                    :disabled="procStatus === 'VIEW'"
                                    v-model="name_ar"
                                    :error-messages="errors"
                                  ></v-text-field>
                                  </ValidationProvider>
                                </div>
                                <div class="box__title">{{ $t('component.applicants.ar') }}</div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pt-0 pb-0">
                      <label class="nec_title"><i>*</i> {{ $t('component.applicants.address') }}</label>
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <div class="text__input__icontype not__ltr">
                            <div class="box__title">{{ $t('component.applicants.en') }}</div>
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.address')" :rules="{required: true}">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus === 'VIEW'"
                                v-model="address_en"
                                :error-messages="errors"
                              ></v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" class="pt-0">
                          <div class="text__input__icontype not__ltr">
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.address')" :rules="{required: true}">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="type_ar ie_inpt login_text_field text-right br_none"
                                :disabled="procStatus === 'VIEW'"
                                v-model="address_ar"
                                :error-messages="errors"
                              ></v-text-field>
                              </ValidationProvider>
                            </div>
                            <div class="box__title">{{ $t('component.applicants.ar') }}</div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0">
                      <v-row>
                        <v-col>
                          <label class="nec_title">{{ $t('component.applicants.pobox') }}</label>
                          <v-row>
                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="box__title">{{ $t('component.applicants.en') }}</div>
                                <div class="text__input__icontype__tf">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="br_none ie_inpt login_text_field text-left"
                                    :disabled="procStatus === 'VIEW'"
                                    v-model="pobox_en"
                                  ></v-text-field>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="text__input__icontype__tf">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="type_ar ie_inpt login_text_field text-right br_none"
                                    :disabled="procStatus === 'VIEW'"
                                    v-model="pobox_ar"
                                  ></v-text-field>
                                </div>
                                <div class="box__title">{{ $t('component.applicants.ar') }}</div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" v-show="residence_country_code === 'EG' && ( applicant_type_code === '2704' || applicant_type_code === '2705' )">
                      <v-row class="">
                        <v-col class="">
                          <h2 class="nec_title"><i v-if="residence_country_code === 'EG' && ( applicant_type_code === '2704' || applicant_type_code === '2705' )">*</i> {{ $t('component.applicants.birthday') }}</h2>
                          <div class="input_text_type_basic">
                            <v-menu
                              ref="menu_date"
                              v-model="menu_date"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.birthday')" :rules="{required: residence_country_code === 'EG' && ( applicant_type_code === '2704' || applicant_type_code === '2705' )}">
                                <v-text-field
                                  outlined
                                  solo
                                  dense
                                  flat
                                  hint="DD/MM/YYYY format"
                                  v-bind="attrs"
                                  v-on="on"
                                  append-icon="mdi-calendar"
                                  class="ft-size12 br_none"
                                  :disabled="procStatus === 'VIEW'"
                                  v-model="birthday_date"
                                  :error-messages="errors"
                                  @click:append="menu_date = true"
                                  readonly
                                ></v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-date-picker v-model="date" :max="today" no-title @input="menu_date = false"></v-date-picker>
                            </v-menu>
                          </div>
                        </v-col>
                        <v-spacer class="hidden_lr5"></v-spacer>
                        <v-col class="">
                          <h2 class="nec_title"><i v-if="residence_country_code === 'EG' && ( applicant_type_code === '2704' || applicant_type_code === '2705' )">*</i> {{ $t('component.applicants.gender') }}</h2>
                          <div class="input_checkbox_type_basic radio_dailog_type row ma-0">
                            <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.gender')" :rules="{required: residence_country_code === 'EG' && ( applicant_type_code === '2704' || applicant_type_code === '2705' )}">
                            <v-radio-group
                              row
                              v-model="gender_type_code"
                              :error-messages="errors"
                            >
                              <template v-for="(genderType, i) in $vuetify.rtl ? genderTypeListAr : genderTypeListEn">
                                <v-radio
                                  :key="genderType.value"
                                  :label="genderType.text"
                                  :value="genderType.value"
                                  :disabled="procStatus === 'VIEW'"
                                >
                                </v-radio>
                                <v-spacer class="hidden_lr10" :key="i" v-if="i==0"></v-spacer>
                              </template>
                            </v-radio-group>
                            </ValidationProvider>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                      <v-row>
                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.applicants.telephone') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-phone-in-talk</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus === 'VIEW'"
                                v-model="telephone"
                              ></v-text-field>
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.applicants.mobile') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-cellphone-iphone</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus === 'VIEW'"
                                v-model="mobile"
                              ></v-text-field>
                            </div>
                          </div>
                        </v-col>


                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.applicants.fax') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-fax</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus === 'VIEW'"
                                v-model="fax"
                              ></v-text-field>
                            </div>
                          </div>

                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                      <v-row>
                        <v-col>
                          <label class="nec_title"><i v-if="nationality_code === 'EG'">*</i> {{ $t('component.applicants.email') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title">@</div>
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.email')" :rules="{required: nationality_code === 'EG', email: true }">
                                <v-text-field
                                  outlined
                                  solo
                                  flat
                                  dense
                                  clearable
                                  class="br_none ie_inpt login_text_field text-left email"
                                  :disabled="procStatus === 'VIEW'"
                                  v-model="email"
                                  :error-messages="errors"
                                ></v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0" v-if="applicant_type_code === '2701' ||
                      (applicant_type_code === '2704' && nationality_code === 'EG') ||
                      (applicant_type_code === '2705' && nationality_code === 'EG')">
                      <label class="nec_title">
                        <i v-if="((applicant_type_code === '2704' || applicant_type_code === '2705') && nationality_code === 'EG') ? true : false">*</i>
                        {{ applicant_type_code === '2704' || applicant_type_code === '2705' ? $t('component.applicants.upload_an_image_of_your_government_issued_photo_id') : $t('component.applicants.commercial_register_or_an_official_extract') }}
                      </label>
                      <v-row>
                        <v-col cols="12" md="6" class="pt-0">
                          <div class="input_text_type_basic file_type fileForm">
                            <ValidationProvider v-slot="{ errors }"
                              :name="(applicant_type_code === '2704' || applicant_type_code === '2705') ? $t('component.applicants.upload_an_image_of_your_government_issued_photo_id') : $t('component.applicants.commercial_register_or_an_official_extract')"
                              :rules="{required: ((applicant_type_code === '2704' || applicant_type_code === '2705') && nationality_code === 'EG' && id_card_file_key === '') ? true : false }">
                              <v-file-input
                                :placeholder="id_card_file_name ? id_card_file_name : $t('common.common.no_files_selected')"
                                outlined
                                dense
                                :prepend-icon="$t('common.common.select_file')"
                                class="ft-size12 br_none wp100"
                                v-model="idCardFile"
                                :error-messages="errors"
                                :disabled="procStatus === 'VIEW'"
                                style="height: 40px;"
                                v-if="procStatus === 'MOD'"
                                accept=".pdf, .jpg, .gif"
                                @change="fnUploadFile()"
                                clearable
                                @click:clear="fnInitFile()"
                                :append-icon="id_card_file_name ? '$clear':''"
                                @click:append="fnInitFile()"
                              >
                              </v-file-input>
                            </ValidationProvider>
                          </div>
                          <div class="input_text_type_basic file_type mt-15">
                            <v-chip
                              v-if="procStatus === 'VIEW'"
                              dark
                              color="#a01c2a"
                              :href="downLoadUrl + id_card_file_key"
                            >
                              <v-icon>{{ getExtIcon(id_card_file_name) }}</v-icon>
                              {{ id_card_file_name }}
                            </v-chip>
                            <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0" v-if="applicant_type_code === '2705'">
                      <label class="nec_title"><i>*</i> {{ $t('component.applicants.student_id_card')}}</label>
                      <v-row>
                        <v-col cols="12" md="6" class="pt-0">
                          <div class="input_text_type_basic file_type fileForm">
                            <ValidationProvider v-slot="{ errors }"
                              :name="$t('component.applicants.student_id_card')"
                              :rules="{required: (student_id_file_key !== '') ? false : true }">
                              <v-file-input
                                :placeholder="student_id_file_name ? student_id_file_name : $t('common.common.no_files_selected')"
                                outlined
                                dense
                                :prepend-icon="$t('common.common.select_file')"
                                class="ft-size12 br_none wp100"
                                v-model="studentIdFile"
                                :disabled="procStatus === 'VIEW'"
                                style="height: 40px;"
                                v-if="procStatus === 'MOD'"
                                :error-messages="errors"
                                accept=".pdf, .jpg, .gif"
                                @change="fnUploadStudentFile()"
                                clearable
                                @click:clear="fnInitStudentFile()"
                                :append-icon="student_id_file_name ? '$clear':''"
                                @click:append="fnInitStudentFile()"
                              >
                              </v-file-input>
                            </ValidationProvider>
                          </div>
                          <div class="input_text_type_basic file_type mt-15">
                            <v-chip
                              v-if="procStatus === 'VIEW'"
                              dark
                              color="#a01c2a"
                              :href="downLoadUrl + student_id_file_key"
                            >
                              <v-icon>{{ getExtIcon(student_id_file_name) }}</v-icon>
                              {{ student_id_file_name }}
                            </v-chip>
                            <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="d-flex align-center justify-space-between pop__btn__wrap">
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        outlined
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus === 'VIEW'"
                        v-show="!remove_restriction"
                        @click="fnDeleteApplicantConfirm()"
                      >
                        {{ $t('common.button.delete') }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        dark
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus === 'VIEW'"
                        @click="fnEditMod()"
                      >
                        {{ $t('common.button.edit') }}
                      </v-btn>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        dark
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus === 'MOD'"
                        @click="fnSave()"
                      >
                        {{ $t('common.button.save') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </perfect-scrollbar>

            </v-form>
          </ValidationObserver>
        </v-col>
      </v-row>
    </v-dialog>

    <v-dialog v-model="confirm_dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('common.message.delete.confirm.title') }}</v-card-title>
        <v-card-text>{{ $t('common.message.delete.confirm.text') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="sb_btn btn-actv" @click="fnDeleteApplicant()">{{ $t('common.button.yes') }}</v-btn>
          <v-btn class="sb_btn btn-dactv" @click="confirm_dialog = false">{{ $t('common.button.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'ChangeOwnershipApplicantsMod',
  props: {
    seq : Number,
    receipt_no : String,
    remove_restriction: Boolean
  },
  components :{
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      today: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substr(0, 10),
      menu_date: false,
      mod_dialog: true,
      confirm_dialog : false,
      procStatus : 'VIEW',
      idCardFile : null,
      studentIdFile: null,
      valid: false,

      applicantTypeListAr: [],
      applicantTypeListEn: [],
      countryArList: [],
      countryEnList: [],
      genderTypeListAr: [],
      genderTypeListEn: [],

      applicant_type_code : '2701',
      nationality_code : '',
      residence_country_code : '',
      name_ar : '',
      name_en : '',
      address_ar : '',
      address_en : '',
      pobox_ar : '',
      pobox_en : '',
      birthday_date: this.formatDate(new Date().toISOString().substr(0, 10)),
      gender_type_code : '4001',
      telephone : '',
      mobile : '',
      fax : '',
      email : '',
      id_card_file_key : '',
      id_card_file_name : '',
      student_id_file_key: '',
      student_id_file_name: '',

      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/'
    }
  },
  beforeCreate(){
    //국가목록
    utils.fnGetCountryList('en').then(list => {
      this.countryEnList = list
    }).catch((res)=>{
      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
    })

    utils.fnGetCountryList('ar').then(list => {
      this.countryArList = list
    }).catch((res)=>{
      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
    })

    //성별목록
    let options = {
      upper_code: '4000'
    }
    utils.fnGetCodeList(options).then(list => {
      this.genderTypeListAr = list.ar
      this.genderTypeListEn = list.en
    })

    //Applicant Type Code
    options = {
      upper_code: '2700'
    }
    utils.fnGetCodeList(options).then(list => {
      this.applicantTypeListAr = list.ar
      this.applicantTypeListEn = list.en
    })
  },
  mounted(){
    this.fnGetApplicant()
  },
  watch: {
    date () { this.birthday_date = this.formatDate(this.date)}
  },
  methods: {
    fnGetApplicant(){
      requestApi({
        url: '/receivings/change/ownership/'+this.receipt_no+'/applicant/'+this.seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicant_type_code = res.data.applicant_type_code
            this.nationality_code = res.data.nationality_code
            this.residence_country_code = res.data.residence_country_code
            this.name_ar = res.data.name_ar
            this.name_en = res.data.name_en
            this.address_ar = res.data.address_ar
            this.address_en = res.data.address_en
            this.pobox_ar = res.data.pobox_ar
            this.pobox_en = res.data.pobox_en
            this.birthday_date = res.data.birthday_date
            this.gender_type_code = res.data.gender_type_code
            this.telephone = res.data.telephone
            this.mobile = res.data.mobile
            this.fax = res.data.fax
            this.email = res.data.email
            this.id_card_file_key = res.data.id_card_file_key
            this.id_card_file_name = res.data.id_card_file_name
            this.student_id_file_key = res.data.student_id_file_key
            this.student_id_file_name = res.data.student_id_file_name
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicant()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      let targetObj = document.querySelector('#applicant_wrapper')
      targetObj.scrollTop = 0
      this.procStatus = 'MOD'
    },
    fnClosePopup(){
      this.$emit('success')
    },
    fnEditMod(){
      let targetObj = document.querySelector('#applicant_wrapper')
      targetObj.scrollTop = 0
      this.procStatus = 'MOD'
    },
    fnSave(){
      this.$refs.observer.validate().then((valid) => {
        if(valid){
          this.fnUploadIdCardFile().then(() => {
            this.fnUploadStudentIdFile().then(() => {
              let params = {
                applicant_type_code : this.applicant_type_code,
                nationality_code : this.nationality_code,
                residence_country_code : this.residence_country_code,
                name_ar : this.name_ar,
                name_en : this.name_en,
                address_ar : this.address_ar,
                address_en : this.address_en,
                pobox_ar : this.pobox_ar,
                pobox_en : this.pobox_en,
                birthday_date : this.birthday_date,
                gender_type_code : this.gender_type_code,
                telephone : this.telephone,
                mobile : this.mobile,
                fax : this.fax,
                email : this.email,
                id_card_file_key : this.id_card_file_key,
                student_id_file_key: this.student_id_file_key
              }

              requestApi({
                url: '/receivings/change/ownership/'+this.receipt_no+'/applicant/'+this.seq,
                method: 'PUT',
                data: params,
                callback: (res) => {
                  if(res.res_code === '200'){
                    let option = {
                      text : this.$t('common.message.modify.success'),
                    }
                    eventBus.$emit('SHOW_SNACKBAR', option)
                    this.$emit('success')
                  }else{
                    if (res.res_code === '401012') {
                      utils.setTokenRefresh().then(() => {
                        this.fnSave()
                      })
                    } else {
                      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                    }
                  }
                }
              })
            })
          }).catch((res)=>{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSave()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnDeleteApplicantConfirm(){
      if(!this.remove_restriction){
        this.confirm_dialog = true
      }
    },
    fnDeleteApplicant(){
      if(!this.remove_restriction){
        requestApi({
          url: '/receivings/change/ownership/'+this.receipt_no+'/applicant/'+this.seq,
          method: 'DELETE',
          callback: (res) => {
            if(res.res_code === '200'){
              let option = {
                text : this.$t('common.message.delete.success'),
              }
              eventBus.$emit('SHOW_SNACKBAR', option)
              this.$emit('success')
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnDeleteApplicant()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return ''
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getExtIcon(fileName){
      let fileNameArray = fileName.split(".")
      let ext = fileNameArray[fileNameArray.length - 1].toLowerCase()

      if(ext === 'doc' || ext === 'docx'){
        return 'mdi-file-word'
      }else if(ext === 'xlsx' || ext === 'xls'){
        return 'mdi-file-excel'
      }else if(ext === 'ppt' || ext === 'pptx'){
        return 'mdi-file-ppt'
      }else if(ext === 'pdf'){
        return 'mdi-file-pdf'
      }else if(ext === 'png' || ext === 'bmp' || ext === 'rle' || ext === 'dib' ||ext === 'gif' || ext === 'tif' || ext === 'tiff' || ext === 'jpg' ){
        return 'mdi-file-image'
      }else{
        return 'mdi-paperclip'
      }
    },
    fnUploadIdCardFile(){
      //업로드 할 이미지 파일이 있다면 업로드 실행
      let idCardFile = this.idCardFile
      let target = this

      return new Promise(function(resolve, reject){
        if(idCardFile){
          let formData = new FormData()
          formData.append("file_data", idCardFile)

          requestApi({
            url: '/file/documents/upload',
            method: 'POST',
            data: formData,
            headers : {"Content-Type":"multipart/form-data"},
            callback: (res) => {
              // 파일저장
              if (res.res_code === '200') {
                target.id_card_file_key = res.data.file_key
                resolve()
              }else{
                reject(res)
              }
            }
          })
        }else{
          resolve()
        }
      })
    },
    fnUploadStudentIdFile(){
      //업로드 할 이미지 파일이 있다면 업로드 실행
      let studentIdFile = this.studentIdFile
      let target = this

      return new Promise(function(resolve, reject){
        if(studentIdFile){
          let formData = new FormData()
          formData.append("file_data", studentIdFile)

          requestApi({
            url: '/file/documents/upload',
            method: 'POST',
            data: formData,
            headers : {"Content-Type":"multipart/form-data"},
            callback: (res) => {
              // 파일저장
              if (res.res_code === '200') {
                target.student_id_file_key = res.data.file_key
                resolve()
              }else{
                reject(res)
              }
            }
          })
        }else{
          resolve()
        }
      })
    },
    fnInitFile() {
      this.idCardFile = null
      this.id_card_file_key = ''
      this.id_card_file_name = ''
    },

    fnUploadFile() {
      if(!utils.isNull(this.idCardFile)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.idCardFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.idCardFile = null
            this.id_card_file_key = ''
            this.id_card_file_name = ''
          }, 100)
        }
      }
    },
    fnInitStudentFile() {
      this.studentIdFile = null
      this.student_id_file_key = ''
      this.student_id_file_name = ''
    },

    fnUploadStudentFile() {
      if(!utils.isNull(this.studentIdFile)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.studentIdFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.studentIdFile = null
            this.student_id_file_key = ''
            this.student_id_file_name = ''
          }, 100)
        }
      }
    }

  },
}

</script>